module.exports = __webpack_public_path__ + "img/com.ifisek.instareportapp.png.463a8977.png";